import { inject, Injectable } from '@angular/core';
import {
  Firestore,
  CollectionReference,
  addDoc,
  collection,
} from 'firebase/firestore';
import { FirebaseService } from '../../_firebase/firebase.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {
  private firebase: FirebaseService = inject(FirebaseService);
  private firestore: Firestore = this.firebase.firestore;
  private emailsCol: CollectionReference = collection(this.firestore, 'emails');

  /** À appeler uniquement après que la personne a coché la case de consentement ; `consent` en garde la trace. */
  createNewsletter(email: string) {
    return addDoc(this.emailsCol, {
      email,
      date: new Date().toISOString(),
      consent: true
    });
  }

  readAllNewsletters(): Observable<string[]> {
    return this.firebase.collectionData(this.emailsCol).pipe(
      map(docs => (docs as { email: string }[]).map(d => d.email))
    );
  }
}
